export enum ExcelExistingEmailAddressType {
    Undefined = 0,
    First = 1,
    All = 2
}
